/**
 * Built-ins that Safari only gained in iOS 15.4 (March 2022).
 *
 * The bundle's syntax targets Safari 14 (see `build.target`), but Vite does
 * not polyfill library functions, and code that calls these crashes on an
 * older iPhone. With no error boundary that was a blank white page: the
 * dashboard called `.at(-1)` on every render. Imported first in index.tsx so it
 * runs before any other module evaluates.
 */

if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: (obj: object, key: PropertyKey) => Object.prototype.hasOwnProperty.call(obj, key),
    configurable: true,
    writable: true,
  });
}

function at<T>(this: ArrayLike<T>, index: number): T | undefined {
  const n = Math.trunc(index) || 0;
  const i = n < 0 ? this.length + n : n;
  return i < 0 || i >= this.length ? undefined : this[i];
}

const TYPED_ARRAY = Object.getPrototypeOf(Int8Array.prototype);
for (const proto of [Array.prototype, String.prototype, TYPED_ARRAY]) {
  if (!('at' in proto)) {
    Object.defineProperty(proto, 'at', { value: at, configurable: true, writable: true });
  }
}

export {};
